import styles from './NavItemsList.module.scss';

import cx from 'classnames';
import React from 'react';

import { ContentType, LinkSet, NavigationItem } from 'api/contentful/contentTypes.cloverdotcom';
import { NavSubItem } from 'components/NavBar/NavItemsList/NavSubItem/NavSubItem';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';

import type { INavListLinkProps } from './NavListLink/NavListLink';

interface INavItemsListProps
  extends React.HTMLAttributes<HTMLDivElement>,
    Pick<INavListLinkProps, 'closeDrawer'> {
  entry?: FlatEntry<NavigationItem>;
}

export const NavItemsList: React.FC<INavItemsListProps> = ({ entry, className, closeDrawer, ...props }) => {
  const items = (entry as FlatEntry<LinkSet>)?.items;
  if (!items) return null;

  const navSubItems = items.filter(link => link.contentType === ContentType.NAV_SUB_ITEM);
  if (!navSubItems.length) return null;

  return (
    <div className={cx(styles.drawerContent, className)} {...props}>
      <ul className={styles.navItemsList}>
        {navSubItems.map((item, index) => {
          return (
            <NavSubItem
              entry={item}
              className={styles.navItemsListSubItem}
              key={componentKeyV2(item, index)}
              closeDrawer={closeDrawer}
            />
          );
        })}
      </ul>
    </div>
  );
};

NavItemsList.displayName = 'NavItemsList';
